import { reactive } from "vue";

export const MAX_DURATION = 60;
export const MIN_DURATION = 2;
export const MAX_FRAME_COUNT = 300;
export const MAX_FRAME_RATE = 30;

export enum AspectRatios {
  AR16x9 = "16:9",
  AR1x1 = "1:1",
  AR4x5 = "4:5",
  AR9x16 = "9:16"
}

export type Settings = {
  videoUrl?: string;
  startTime: number;
  endTime: number;
  frameRate: number;
  aspectRatio: AspectRatios;
};

export const DEFAULT_ENCODE_SETTINGS: Settings = {
  videoUrl: undefined,
  startTime: 0,
  endTime: 30,
  frameRate: 10,
  aspectRatio: AspectRatios.AR16x9
};

const settings = reactive<Settings>({ ...DEFAULT_ENCODE_SETTINGS });

export default () => {
  const resetSettings = () => {
    Object.assign(settings, {
      ...DEFAULT_ENCODE_SETTINGS
    });
  };

  const updateSettings = (values: Partial<Settings>) => {
    Object.assign(settings, {
      ...values
    });
  };

  return { resetSettings, updateSettings, settings };
};
